import { Box, Checkbox, Container, FormControlLabel, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

class OmisionesFuncionario extends Component {
    constructor(props){
        super(props);
        this.state = {

            datos: {
                numeroFuncionario: '',
                anio: '',
            },

            omisionesMarcas: [],
            omisionesMHD: [],
            consultaOmisiones: false,
            consultaOMHD: false,
            modalBorrarMH: false,
            modalBorrarES: false,

            errores: null,
            notificaciones: null,

            checkOmisiones: {
                ambos: true,
                marcas: false,
                mediaHora: false,
            },

            omiBorrar: {
                idOmisiones: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                codigo: '',
                tipoOmision: '',
                marcaOmision: '',
                fechaOmision: '',
            },

        }

        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.cambioListadoConsulta = this.cambioListadoConsulta.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejarEnvioBajaMH = this.manejarEnvioBajaMH.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.manejarBorrarES = this.manejarBorrarES.bind(this);
        this.manejarBorrarMH = this.manejarBorrarMH.bind(this);
        this.manejarEnvioBajaES = this.manejarEnvioBajaES.bind(this);
    }

    async componentDidMount(){}
    render() {
        return (
            <>
                <Container>
                    <form className='formulario'  onSubmit={this.manejoEnvioNumeroFuncionario}>
                        <h3>Omisiones Funcionario</h3>
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.1}>
                                    <Item>Número de Funcionario <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionario' value={this.state.datos.numeroFuncionario} onChange={this.manejarCambiosDatos} type="text" /></Item>
                                </Grid>
                                <Grid item xs={2.1}>
                                    <Item>Año</Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='anio' value={this.state.datos.anio} onChange={this.manejarCambiosDatos} type="number" /></Item>
                                </Grid>
                                <Grid item xs={1}>
                                    <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Container>
                <Container>
                    <FormControlLabel label='Omisiones Marca/Media Hora' control={<Checkbox checked={this.state.checkOmisiones.ambos} onChange={this.cambioListadoConsulta} id='ambos'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                    <FormControlLabel label='Omisiones Marca' control={<Checkbox checked={this.state.checkOmisiones.marcas} onChange={this.cambioListadoConsulta} id='marcas'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                    <FormControlLabel label='Omisiones Media Hora' control={<Checkbox checked={this.state.checkOmisiones.mediaHora} onChange={this.cambioListadoConsulta} id='mediaHora'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.consultaOmisiones && (this.state.checkOmisiones.ambos || this.state.checkOmisiones.marcas)
                    ?
                        <TableContainer>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="center" colSpan={5}>Omisiones de Marcas</StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCell>N. Funcionario</StyledTableCell>
                                        <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                        <StyledTableCell>Fecha</StyledTableCell>
                                        <StyledTableCell>Marca</StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.omisionesMarcas.map((datosOmi) => (
                                        <StyledTableRow key={datosOmi.idOmisiones}>
                                            <StyledTableCell>{datosOmi.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell>{datosOmi.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>{datosOmi.fechaOmision}</StyledTableCell>
                                            <StyledTableCell>{datosOmi.marcaOmision}</StyledTableCell>
                                            <StyledTableCell><button className="btn btn-outline-dark mx-2" type='button' onClick={() => this.manejarBorrarES(datosOmi)}>Borrar</button></StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    :
                        null
                    }
                    <br/>
                    <br/>
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.consultaOmisiones && (this.state.checkOmisiones.ambos || this.state.checkOmisiones.mediaHora)
                    ?
                        <TableContainer>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="center" colSpan={5}>Omisiones Media Hora Descanso</StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCell>N. Funcionario</StyledTableCell>
                                        <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                        <StyledTableCell>Fecha</StyledTableCell>
                                        <StyledTableCell>Marca</StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.omisionesMHD.map((datosOmi) => (
                                        <StyledTableRow key={datosOmi.idOmisiones}>
                                            <StyledTableCell>{datosOmi.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell>{datosOmi.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>{datosOmi.fechaOmision}</StyledTableCell>
                                            <StyledTableCell>{datosOmi.marcaOmision}</StyledTableCell>
                                            <StyledTableCell><button className="btn btn-outline-dark mx-2" type='button' onClick={() => this.manejarBorrarMH(datosOmi)}>Borrar</button></StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    :
                        null
                    }
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.consultaOmisiones
                    ?
                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button>
                    :
                        null
                    }
                </Container>
                <Modal open={this.state.modalBorrarMH}>
                    <form className='formulario1'>
                        <Box sx={styleModal}>
                            <h3 style={{textAlign:'center'}}>¿Confirmar Baja Marca Manual?</h3>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioBajaMH}>Confirmar</button>
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>
                <Modal open={this.state.modalBorrarES}>
                    <form className='formulario1'>
                        <Box sx={styleModal}>
                            <h3 style={{textAlign:'center'}}>¿Confirmar Baja Marca Manual?</h3>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioBajaES}>Confirmar</button>
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>
                <br/>
                <br/>
            </>
        )
    }

    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        if(this.state.datos.numeroFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar el número de funcionario!',
            })
        }else{

            const cargaUtil = JSON.stringify([this.state.datos]);
            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_omisiones.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            this.setState({
                errores: exito[0],
                notificaciones: null,
                consulta: false,
            });

            if(exito[0] === 'ok'){
                this.setState({
                    errores: null,
                    omisionesMarcas: exito[1],
                    omisionesMHD: exito[2],
                    consultaOmisiones: true,
                    consultaOMHD: false,
                })
            }
        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            omisionesMarcas: [],
            omisionesMHD: [],
            consultaOmisiones: false,
            consultaOMHD: false,
            modalBorrarMH: false,
            modalBorrarES: false,
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const funcionarioActualizado = state.datos;
            funcionarioActualizado[clave] = valor;
            return{
                datos: funcionarioActualizado,
            };
        })
    }

    async cambioListadoConsulta(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.checked;
        this.setState({
            errores: null,
            notificaciones: null,
            modalBorrarMH: false,
            modalBorrarES: false,
        });

        if(clave === 'ambos'){

            if(valor){
                this.setState({
                    checkOmisiones: {
                        ambos: true,
                        marcas: false,
                        mediaHora: false,
                    },
                });
            }
        }else if(clave === 'marcas'){

            if(valor){
                this.setState({
                    checkOmisiones: {
                        ambos: false,
                        marcas: true,
                        mediaHora: false,
                    },
                });
            }
        }else if(clave === 'mediaHora'){

            if(valor){
                this.setState({
                    checkOmisiones: {
                        ambos: false,
                        marcas: false,
                        mediaHora: true,
                    },
                });
            }
        }
    }

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            datos: {
                numeroFuncionario: '',
                anio: '',
            },

            omisionesMarcas: [],
            omisionesMHD: [],
            consultaOmisiones: false,
            consultaOMHD: false,
            modalBorrarMH: false,
            modalBorrarES: false,

            errores: null,
            notificaciones: null,

            checkOmisiones: {
                ambos: true,
                marcas: false,
                mediaHora: false,
            }
        })
    }

    manejarBorrarMH(dato){
        this.setState({
            modalBorrarMH: true,
            modalBorrarES: false,
            omiBorrar: dato,
            notificaciones: null,
            errores: null,
        });
    }

    manejarBorrarES(dato){
        this.setState({
            modalBorrarMH: false,
            modalBorrarES: true,
            omiBorrar: dato,
            notificaciones: null,
            errores: null,
        });
    }

    async manejarEnvioBajaMH(e){
        e.preventDefault();

        const cargaUtil = JSON.stringify([this.state.omiBorrar, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/borrar_omision.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();

        if(exito[0] === 'ok'){
            let contador = 0;
            const arr = this.state.omisionesMHD;
            arr.map((name) => {
                if(this.state.omiBorrar.idOmisiones === name.idOmisiones){
                    arr.splice(contador, 1);
                }else{
                    contador++;
                }
            });
            this.setState({
                notificaciones: 'Los datos fueron borrados correctamente',
                modalBorrarMH: false,
                modalBorrarES: false,
                omisionesMHD: arr,
                errores: null,
            });
        }
    }

    cerrarModal(e){
        e.preventDefault();
        this.setState({
            datos: {
                numeroFuncionario: '',
                anio: '',
            },
            modalBorrarMH: false,
            modalBorrarES: false,

            errores: null,
            notificaciones: null,

            omiBorrar: {
                idOmisiones: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                codigo: '',
                tipoOmision: '',
                marcaOmision: '',
                fechaOmision: '',
            },
        })
    }

    async manejarEnvioBajaES(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.omiBorrar, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/borrar_omision.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        if(exito[0] === 'ok'){
            let contador = 0;
            const arr = this.state.omisionesMarcas;
            arr.map((name) => {
                if(this.state.omiBorrar.idOmisiones === name.idOmisiones){
                    arr.splice(contador, 1);
                }else{
                    contador++;
                }
            });
            this.setState({
                notificaciones: 'Los datos fueron borrados correctamente',
                modalBorrarMH: false,
                modalBorrarES: false,
                omisionesMarcas: arr,
                errores: null,
            });
        }
    }
}

export default OmisionesFuncionario